import React from 'react';

export type FilterSwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  /** Optional content inside the thumb (e.g. Finland flag). Keep small; thumb is fixed size. */
  thumbContent?: React.ReactNode;
  className?: string;
};

const TRACK =
  'relative inline-flex h-8 w-[51px] shrink-0 cursor-pointer rounded-full p-[3px] transition-[background-color] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-jc-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jc-surface disabled:cursor-not-allowed disabled:opacity-45';

const THUMB =
  'pointer-events-none flex h-[26px] w-[26px] items-center justify-center rounded-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.12),0_1px_1px_rgba(0,0,0,0.08)] transition-transform duration-[180ms] ease-[cubic-bezier(0.25,0.8,0.25,1)] dark:bg-[#E8E6E3] dark:shadow-[0_2px_6px_rgba(0,0,0,0.4)]';

/**
 * macOS-style on/off switch for filter rows. Uses JobCrawls jc colours (forest when on).
 */
export function FilterSwitch({
  checked,
  onCheckedChange,
  disabled = false,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
  thumbContent,
  className = '',
}: FilterSwitchProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      onClick={() => !disabled && onCheckedChange(!checked)}
      className={`${TRACK} ${checked ? 'bg-jc-cta' : 'bg-jc-border'} ${className}`}
    >
      <span
        className={`${THUMB} ${checked ? 'translate-x-[19px]' : 'translate-x-0'}`}
        aria-hidden
      >
        {thumbContent}
      </span>
    </button>
  );
}
